/* Built In Imports */
import config from '@config';
/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { usePageConfigValue } from '@ieo/hooks/usePageConfigVal';

/* Internal Imports */
/* Components */

import SliderExperience from '@ieo/Components/SliderExperience';
/* Services */
/* Styles */

/**
 *
 * @param {Object} SectionContent
 *  @param {String} lang
 *  @param {String} region
 * @returns ProgramTestimonial
 */
const ProgramTestimonialV3 = ({
  sectionContent,
  region,
  lang,
  pageData,
  prgData,
}) => {
  const currentCoupon = Object.values(prgData)[0]?.coupon;

  const { pageConfigVal, isThemeActive } = usePageConfigValue(
    pageData,
    region,
    currentCoupon
  );

  return (
    <Box
      background={{
        base: isThemeActive
          ? `url(${pageConfigVal?.prgFees?.bgImage?.mob})  #00005B`
          : `url(${config.imgPath}/d/46272/1700299128-ieo-bluebg-2-1.png) #00005B`,
        md: isThemeActive
          ? `url(${pageConfigVal?.prgFees?.bgImage?.tab})  #00005B`
          : `url(${config.imgPath}/d/46272/1700299128-ieo-bluebg-2-1.png) #00005B`,
        lg: isThemeActive
          ? `url(${pageConfigVal?.prgFees?.bgImage?.desktop})  #00005B`
          : ` url(${config.imgPath}/d/46272/1700299128-ieo-bluebg-2-1.png) #00005B`,
        xl: isThemeActive
          ? `url(${pageConfigVal?.prgFees?.bgImage?.bigScreen}) #00005B`
          : ` url(${config.imgPath}/d/46272/1700299128-ieo-bluebg-2-1.png) #00005B`,
      }}
    >
      <Flex maxW="1330px" flexDir="column" margin={'0 auto'}>
        <Box
          pos={{ base: 'static', md: 'relative' }}
          top="30px"
          // h={{ base: '640px', md: '500px', lg: '520px' }}
        >
          <SliderExperience
            sectionContent={sectionContent?.[0]}
            lang={lang}
            region={region}
            paddingBottom={'50px'}
            heightBase={'auto'}
            color="#fff"
            arrowTop="inherit"
            left="15%"
            right="-3%"
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default ProgramTestimonialV3;
